import { Link } from 'react-router-dom';
import { StatusBadge } from '../../../shared/components/StatusBadge';
import { DataTableRow } from '../../../shared/components/DataTable';
import { TrackingEventRecord } from './api';

function formatDate(d: string | null): string {
  if (!d) return '—';
  return new Date(d).toLocaleString();
}

export function trackingEventToRow(evt: TrackingEventRecord): DataTableRow {
  return {
    id: evt.id,
    cells: [
      evt.consignment ? (
        <Link to={`/admin/carrier-control/consignments/${evt.consignment.id}`} key="con">
          {evt.consignment.tntConsignmentNumber ?? evt.consignmentId}
        </Link>
      ) : (
        evt.consignmentId
      ),
      <StatusBadge status={evt.status} key="status" />,
      evt.description ?? '—',
      formatDate(evt.occurredAt),
    ],
  };
}
